import React from 'react';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';
import './styles.css';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentSlide: 0
        };
    }

    getSliderPosition() {
        return `${this.state.currentSlide * -100}%`;
    }

    onChangeSlide = (count) => e => {
        if (
            (this.state.currentSlide + count >= this.props.data.slides.length) ||
            (this.state.currentSlide + count < 0)
        ) {
            return;
        }

        this.setState({
            currentSlide: this.state.currentSlide + count,
        })
    };

    render() {
        const { currentSlide } = this.state;
        const slides = this.props.data.slides;

        return (
            <div>
                <div className="gallery__wrapper">
                    <div className="gallery-slide__window">
                        {currentSlide > 0 &&
                        <div onClick={this.onChangeSlide(-1)} className="gallery__arrow gallery__arrow_left">
                            <div className="gallery__arrow-ic">
                                <ArrowBack color="white"/>
                            </div>
                        </div>
                        }
                        <div
                            className="gallery-slide__inner"
                            style={ {
                                transform: `translateX(${this.getSliderPosition()})`,
                            } }
                        >
                            { slides.map((s, i) => (
                                <img className="gallery-slide" key={ i } src={s.previewUrl} alt="#"/>
                            ))}
                        </div>
                        {currentSlide < slides.length - 1 &&
                        <div onClick={this.onChangeSlide(1)} className="gallery__arrow gallery__arrow_right">
                            <div className="gallery__arrow-ic">
                                <ArrowForward color="white"/>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// src/components/editor/GallerySlider/GallerySlider.js